/** @format */
import styled from 'styled-components';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const FlagWrapper = styled.span`
    display: flex;
    height: 1.6rem;
    width: 2.4rem;
`;
